import { useMemo, useState } from "react";
import { useSelector } from "react-redux";

import type { ReduxState } from "@dashboard/types";

/**
 * The menu URL being previewed: first one using the preferred theme, else the
 * first, following deletes.
 */
export const useMenuUrlChoice = (preferThemeId?: string) => {
  const menuUrlsV2 = useSelector(
    (state: ReduxState) => state.menuUrlV2.menuUrlsV2
  );
  const [chosenId, setDocId] = useState(
    () => menuUrlsV2.find((m) => m.themeId === preferThemeId)?.docId ?? ""
  );
  const menuUrl = menuUrlsV2.find((m) => m.docId === chosenId) ?? menuUrlsV2[0];

  const options = useMemo(
    () =>
      menuUrlsV2.map((m) => ({
        value: m.docId,
        label: m.displayName || m.urlSlug,
      })),
    [menuUrlsV2]
  );

  return { menuUrl, docId: menuUrl?.docId ?? "", setDocId, options };
};
